import { AuthLayout } from 'src/layouts';

export const AccountNotActive = () => {
  return (
    <AuthLayout>
      <h1>Account Not Active</h1>
    </AuthLayout>
  );
};
